// extracted by mini-css-extract-plugin
export default {"container":"SLyzvN","button":"PNU_pt","icon":"qFbnLr","tooltipInner":"EN3nbL","tooltipText":"Qm8ueN","tooltip":"GafID7"};